import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Checkbox } from "../ui/checkbox";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Button } from "../ui/button";

const tiposBase = ["fotos", "vídeos", "projetos", "ensaios", "memoriais", "croquis"];

const StepAnexos = ({ anexos, onChange, onSave, hasManifestacoes, readOnly }) => {
  const data = anexos || {};
  const toggle = (tipo) => {
    const current = data.tipos || [];
    const next = current.includes(tipo) ? current.filter((item) => item !== tipo) : [...current, tipo];
    onChange({ ...data, tipos: next });
  };

  return (
    <Card>
      <CardHeader><CardTitle>Documentos e Anexos Complementares</CardTitle></CardHeader>
      <CardContent className="space-y-6">
        {hasManifestacoes && !(data.tipos?.length || data.observacoes) && (
          <div className="rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800">
            Há manifestações registradas, mas esta seção ainda está vazia.
          </div>
        )}
        <div className="rounded-lg border bg-[#F5F2EB] px-4 py-3 text-sm text-[#4A5568]">
          Esta etapa registra metadados dos anexos. O armazenamento de arquivos pode ser tratado separadamente.
        </div>
        <div className="space-y-2">
          <Label>Tipos de anexos</Label>
          {tiposBase.map((tipo) => (
            <label key={tipo} className="flex items-center gap-2 text-sm">
              <Checkbox checked={(data.tipos || []).includes(tipo)} onCheckedChange={() => toggle(tipo)} disabled={readOnly} />
              {tipo}
            </label>
          ))}
        </div>
        <div><Label>Quantidade de fotos</Label><Input type="number" value={data.quantidade_fotos || 0} disabled={readOnly} onChange={(e) => onChange({ ...data, quantidade_fotos: Number(e.target.value) })} /></div>
        <div><Label>Organização do relatório fotográfico</Label><Input value={data.organizacao_relatorio_fotografico || ""} disabled={readOnly} onChange={(e) => onChange({ ...data, organizacao_relatorio_fotografico: e.target.value })} /></div>
        <div><Label>Observações</Label><Textarea value={data.observacoes || ""} disabled={readOnly} onChange={(e) => onChange({ ...data, observacoes: e.target.value })} /></div>
        {!readOnly && <Button onClick={onSave}>Salvar</Button>}
      </CardContent>
    </Card>
  );
};

export default StepAnexos;
